import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpecialModule } from 'lib/modules/special.module';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { WebpService } from 'lib/services/webp.service';
import get from 'lodash-es/get';
@Component({
    selector: 'cms-partial-category-top-component-full-width-block',
    templateUrl: './full-width-block.component.html',
    styleUrls: ['./full-width-block.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CommonModule, SpecialModule],
})
export class FullWidthBlockComponent extends CmsPartialComponentClass implements OnInit {
    @Input() fullWidthRow: any;
    hasPadding: boolean = false;
    hasMargins: boolean = false;
    getWebpImg: (src: string) => string;
    constructor(webpService: WebpService, breakpointObserver: BreakpointObserver) {
        super({
            dependencies: {
                webpService: webpService,
                breakpointObserver: breakpointObserver,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }
    getFullWidthBlockSrc(srcObj: Object) {
        let src = '';
        if (this.isNarrow) {
            src = get(srcObj, 'full_width_block[0].image_mobile.href');
            src = src ? src : get(srcObj, 'full_width_block[0].image_desktop.href');
        } else {
            src = get(srcObj, 'full_width_block[0].image_desktop.href');
        }
        return src;
    }
    getMobileTitle(fullWidthRow: any): string {
        const mobileTitle = this.get(fullWidthRow, 'full_width_block.full_width_block[0].image_mobile.title');
        if (mobileTitle !== '') {
            return mobileTitle;
        }
        // Fall back to desktop title if mobile title is empty
        return this.get(fullWidthRow, 'full_width_block.full_width_block[0].image_desktop.title');
    }
    ngOnInit() {
        if (this.fullWidthRow.full_width_block.full_width_block[0].top_and_bottom_spacing) {
            this.hasPadding = true;
        }
        if (this.fullWidthRow.full_width_block.full_width_block[0].side_margins) {
            this.hasMargins = true;
        }
    }
}
